import React from 'react';
import PropTypes from 'prop-types';
import {
  ID_ME_MARK_ASPECT,
  ID_ME_MARK_PATHS,
  ID_ME_MARK_VIEWBOX,
} from './idMeMark';

// TODO(WA-2172): replace with <FragnoLogoLockup variant="light" /> once the rebranded mark
// ships in a stable fragno release.
const IdMeLogo = ({ ariaLabel, height }) => (
  <span role="img" aria-label={ariaLabel}>
    <svg
      width={height * ID_ME_MARK_ASPECT}
      height={height}
      viewBox={ID_ME_MARK_VIEWBOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {ID_ME_MARK_PATHS.map(({ d, evenOdd }, index) => (
        <path
          key={index}
          fillRule={evenOdd ? 'evenodd' : undefined}
          clipRule={evenOdd ? 'evenodd' : undefined}
          d={d}
          fill="currentColor"
        />
      ))}
    </svg>
  </span>
);

IdMeLogo.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  height: PropTypes.number,
};

IdMeLogo.defaultProps = {
  height: 36,
};

export default IdMeLogo;
